import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const YearGroupsReducer = combineReducers({
  fetching: createRequestReducer('YEAR_GROUPS:FETCHING', { pending: true }),
  yearGroups: createReducer(null, {
    'YEAR_GROUPS:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data.year_groups
  })
})

export default YearGroupsReducer
